import React from "react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

export default function About() {
  return (
    <div className="bg-parchment min-h-screen" data-testid="about-page">
      <PublicNav />
      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-24 pb-16">
        <div className="overline">About — Pure brokerage, transparent intermediary</div>
        <h1 className="h-serif text-5xl md:text-6xl text-ink mt-5 leading-[1.05]">
          We were founded on a single, stubborn idea: that the markets which feed
          and fuel the world deserve <span className="italic text-oxblood">unshakeable</span> intermediaries.
        </h1>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-10 pb-20 prose-lg">
        <p className="text-sub leading-[1.85] text-lg">
          Campbell&apos;s Commodities Brokerage LLC is a Delaware-registered intermediary.
          We do not hold inventory. We do not take title. We do not own a single
          drum of jet fuel or a single bag of ICUMSA 45. Our product is the deal —
          and the legal scaffolding around it.
        </p>
        <div className="divider-rule my-14" />
        <p className="text-sub leading-[1.85] text-lg">
          The firm was assembled by procurement veterans who spent careers inside
          refineries, sugar mills, coffee cooperatives and freight desks — and
          watched, again and again, as opacity ate value. Misquoted lots. Lanes
          that vanished mid-shipment. Suppliers who promised volumes they could
          not deliver. And worse, the recurring failure of brokers: introduce two
          parties, watch them close around the broker, walk away unpaid. We built
          a platform whose entire purpose is to make that failure impossible.
        </p>
        <div className="divider-rule my-14" />
        <p className="text-sub leading-[1.85] text-lg">
          The product is a deal-flow intake system. Every transaction passes
          through the same enforced sequence: ICPO &amp; BCL on intake, sanitized RFQ
          to a vetted seller, FCO on return, NCNDA before any handshake, IMFPA
          lodged with the banks, and only then the SPA. Our commission is wired
          off the top of the buyer&apos;s Letter of Credit — not extracted afterwards,
          not negotiated again, not subject to a counterparty&apos;s memory.
        </p>
        <div className="divider-rule my-14" />
        <p className="text-sub leading-[1.85] text-lg">
          The commitment is simple: deliver verified counterparties on protected
          terms. Discretion is the product. The paperwork is the contract.
          Everything else is theatre.
        </p>
      </section>

      <section className="bg-parchment2 border-y border-line">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-3 gap-10">
          {[
            { k: "We Do Not Touch the Product", v: "No warehouse. No vessel charter. No title risk. We orchestrate the contract — banks and freight forwarders do the rest." },
            { k: "The Sequence Is Sacred",      v: "NCNDA first, IMFPA second, SPA last. Anyone who asks us to skip steps disqualifies themselves." },
            { k: "Bank-Routed Commissions",     v: "Our fee is split off at the LC clearing layer. It does not depend on the seller remembering to wire us afterwards." },
          ].map((c) => (
            <div key={c.k} className="border border-line bg-parchment p-8" data-testid={`about-pillar-${c.k.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="overline">Pillar</div>
              <h3 className="h-serif text-2xl mt-3 text-ink">{c.k}</h3>
              <p className="text-sub mt-3 text-sm leading-relaxed">{c.v}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
